import { render, staticRenderFns } from "./ArmsValidation.vue?vue&type=template&id=1608df7f"
import script from "./ArmsValidation.vue?vue&type=script&lang=js"
export * from "./ArmsValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports